/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import styles from '../../styles';

const Wrapper = styled.div`
  border-top-right-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-bottom: 1px solid #dddbda;
  padding: 1rem;
  text-align: center;
`;

const MainText = styled.div`
  ${styles.fonts.headingLarge}
`;

class ModalHeader extends React.Component {
  render() {
    const { children, text }= this.props;

    return (
      <Wrapper>
        <MainText>
        { (text) ? text : children }
        </MainText>
      </Wrapper>
    );
  }
}

export default ModalHeader;
